import { useEffect, useRef, useState } from 'react'
import { Search } from 'lucide-react'
import { cn } from '@/lib/utils'

interface Props {
  value: string
  onChange: (v: string) => void
  placeholder?: string
  debounceMs?: number
  className?: string
}

/** 250ms 디바운스 + 검색 아이콘.
 *  바깥 value 는 '밖에서 바뀐 경우'(초기화 등)만 입력칸에 반영한다 — 우리가 보낸 값이 돌아온 것까지
 *  덮어쓰면 그 사이 더 친 글자가 지워지고 한글 조합이 깨진다(거래처관리 1,500줄, 고객 지적 2026-10-20). */
export function SearchBox({ value, onChange, placeholder = '검색', debounceMs = 250, className }: Props) {
  const [local, setLocal] = useState(value)
  const sent = useRef(value)

  useEffect(() => {
    if (value !== sent.current) {
      sent.current = value
      setLocal(value)
    }
  }, [value])

  useEffect(() => {
    const t = setTimeout(() => {
      if (local !== value) {
        sent.current = local
        onChange(local)
      }
    }, debounceMs)
    return () => clearTimeout(t)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [local])

  return (
    <div className={cn('relative', className)}>
      <input
        type="text" value={local} onChange={(e) => setLocal(e.target.value)}
        placeholder={placeholder}
        data-role="search-box"
        className="w-full pl-10 pr-3 py-2 rounded-lg border border-slate-300 focus:border-blue-500 focus:ring-2 focus:ring-blue-100 text-sm outline-none bg-white"
      />
      <Search className="absolute left-3.5 top-2.5 w-4 h-4 text-slate-400" />
    </div>
  )
}
